import lodashRound from 'lodash/round';
import { marginToMarkup, markupToMargin } from '@/components/prices/utils/price-math';
import { useCurrencies } from '@/store/currencies';
import isNil from 'lodash/isNil';

/**
 * Formats a price range for display.
 * Single value: "100 SEK" (or "100 kr" with useSymbol)
 * Range: "100 - 150 SEK" (or "100 - 150 kr" with useSymbol)
 */
export const formatPriceRange = (
  minAmount: number | undefined,
  maxAmount: number | undefined,
  currencyId: number | undefined,
  options?: { useSymbol?: boolean }
): string | null => {
  if (isNil(minAmount) && isNil(maxAmount)) {
    return null;
  }
  if (isNil(currencyId)) {
    return null;
  }
  const currencies = useCurrencies();

  if (options?.useSymbol) {
    if (minAmount === maxAmount) {
      return currencies.formatPrice(minAmount!, currencyId)!;
    }
    return `${currencies.formatPrice(minAmount!, currencyId)} - ${currencies.formatPrice(maxAmount!, currencyId)}`;
  }

  const currencyCode = currencies.getById(currencyId)?.code ?? '';
  if (minAmount === maxAmount) {
    return `${minAmount} ${currencyCode}`.trim();
  }
  return `${minAmount} - ${maxAmount} ${currencyCode}`.trim();
};

export const formatNumber = (
  number?: number,
  options?: { abs?: true; decimals?: number; markupToMargin?: boolean; marginToMarkup?: boolean }
) => {
  if (isNil(number)) {
    return undefined;
  }
  if (options?.markupToMargin) {
    number = markupToMargin(number);
  }

  if (options?.marginToMarkup) {
    number = marginToMarkup(number);
  }

  if (options?.abs) number = Math.abs(number);
  return lodashRound(number, options?.decimals ?? 2);
};
